import { useEffect } from 'react';
export function useGlobalKeyDown(onKeyDown) {
    return useEffect(() => {
        addEventListener('keydown', onKeyDown);
        return () => removeEventListener('keydown', onKeyDown);
    }, [onKeyDown]);
}
//# sourceMappingURL=useGlobalKeyDown.js.map